import ApiService from "@/common/api.service";

const PATH = "stock/inventory";

export const GET_STOCK_INVENTORY = "getStockInventory";
export const GET_STOCK_INVENTORY_LOT_BREAKDOWN = "getStockInventoryLotBreakdown";
export const GET_STOCK_INVENTORY_REQUIREMENTS_LIST = "getStockInventoryRequirementsList";
export const GET_STOCK_INVENTORY_SUMMARY = "getStockInventorySummary";

const actions = {
  [GET_STOCK_INVENTORY](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.query(PATH, {
        ...(params || {}),
        ...context.rootGetters.stockContextFilterParams,
      })
        .then(({ data }) => resolve(data))
        .catch(({ response }) => reject(response.data));
    });
  },

  [GET_STOCK_INVENTORY_LOT_BREAKDOWN](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.query("stock/inventory/lot-breakdown", {
        ...(params || {}),
        ...context.rootGetters.stockContextFilterParams,
      })
        .then(({ data }) => resolve(data.data || data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [GET_STOCK_INVENTORY_REQUIREMENTS_LIST](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.query("stock/inventory/requirements-list", {
        ...(params || {}),
        ...context.rootGetters.stockContextFilterParams,
      })
        .then(({ data }) => resolve(data.data || data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [GET_STOCK_INVENTORY_SUMMARY](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.query("stock/inventory/summary", {
        ...(params || {}),
        ...context.rootGetters.stockContextFilterParams,
      })
        .then(({ data }) => resolve(data.data || data))
        .catch(({ response }) => reject(response?.data));
    });
  },
};

export default {
  actions,
};
